import Skeleton from '../skeleton/Skeleton';
import { StyledSettings } from './Settings.styles';

/** One card of label rows with a button each, the shape most settings sections share. */
const CardSkeleton = ({ rows }) => (
  <div className="settings-card">
    {Array.from({ length: rows }).map((_, i) => (
      <div className="settings-row" key={`settings-row-skeleton-${i}`}>
        <div className="row-copy">
          <Skeleton width="160px" height="15px" radius="6px" resp />
          <Skeleton width="260px" height="13px" radius="6px" margin="6px 0 0" resp />
        </div>
        <Skeleton width="128px" height="36px" radius="14px" />
      </div>
    ))}
  </div>
);

/** The page's top sections, shown until the account and the integration keys have arrived. */
const SettingsSkeleton = () => (
  <StyledSettings aria-busy="true">
    <main className="settings-main">
      <header className="settings-head">
        <Skeleton width="140px" height="30px" radius="8px" resp />
        <Skeleton width="440px" height="14px" radius="6px" margin="10px 0 0" resp />
      </header>

      <section className="settings-section">
        <Skeleton width="120px" height="18px" radius="6px" margin="0 0 16px" />
        <div className="settings-card">
          <div className="settings-row">
            <div className="avatar-identity">
              <Skeleton width="56px" height="56px" circle />
              <Skeleton width="160px" height="16px" radius="6px" />
            </div>
            <Skeleton width="128px" height="36px" radius="14px" />
          </div>
          {[0, 1, 2].map(key => (
            <div className="settings-row" key={key}>
              <div className="row-copy">
                <Skeleton width="120px" height="15px" radius="6px" />
                <Skeleton width="200px" height="13px" radius="6px" margin="6px 0 0" resp />
              </div>
              <Skeleton width="128px" height="36px" radius="14px" />
            </div>
          ))}
        </div>
      </section>

      <section className="settings-section">
        <Skeleton width="120px" height="18px" radius="6px" margin="0 0 16px" />
        <div className="settings-card">
          <Skeleton width="100%" height="280px" radius="14px" />
        </div>
      </section>

      <section className="settings-section">
        <Skeleton width="120px" height="18px" radius="6px" margin="0 0 16px" />
        <CardSkeleton rows={1} />
      </section>
    </main>
  </StyledSettings>
);

export default SettingsSkeleton;
